import React, { useState } from 'react';
import { CUSTOMER_LIST, QUERY_KEYS } from '../../../constants';
import { setSafetyMeetingCustomer } from '../../../redux';
import { getAllCustomer, popup } from '../../../utils';
import { useDispatch } from 'react-redux';
import SSCSelect from '../../shared/SSCSelect';
import { isEmpty, sortBy } from 'lodash';
import { useSelector } from 'react-redux';
import { useDebouncedValue } from '../../../hooks/useDebounceValue';
import { useQuery } from '@tanstack/react-query';

const SelectCustomerDD = () => {
    const dispatch = useDispatch();
    const [searchCustomer, setSearchCustomer] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const csmCaseload = useSelector((s) => s.csmCaseload?.csmCaseloadData);

    const [debouncedSearch] = useDebouncedValue(searchCustomer, 500);
    const { data, isFetching, isError, error } = useQuery({
        queryKey: [QUERY_KEYS.CUSTOMERS, debouncedSearch, csmCaseload?.id, csmCaseload?.role_code],
        queryFn: async () =>
            await getAllCustomer({
                offset: 1,
                limit: 50,
                search: debouncedSearch,
                id: csmCaseload?.id,
                role: csmCaseload?.role_code,
                hasPrimaryUser: true,
            }),
        select: (data) =>
            sortBy(data?.data?.map((customer) => ({ label: customer.name, value: customer }))) ||
            [],
    });

    if (isError) popup('error', error.message);

    const handleClose = (data) => {
        if (isEmpty(data)) {
            dispatch(setSafetyMeetingCustomer({}));
            setSelectedCustomer(null);
            return;
        }
        dispatch(
            setSafetyMeetingCustomer({
                id: data.id,
                name: data.name,
                primaryUserId: data.primary_user_id,
            }),
        );
        setSelectedCustomer({ id: data.id });
    };

    return (
        <div className='col-6'>
            <SSCSelect
                required
                isClearable
                label={CUSTOMER_LIST.PAGE_HEADING}
                options={data}
                onChange={(d) => handleClose(d?.value)}
                onInputChange={setSearchCustomer}
                formatOptionLabel={({ label, value }) =>
                    value?.email ? (
                        <div className='d-flex flex-column'>
                            <span>{label}</span>
                            <span style={{ fontSize: '12px' }} className='text-black-50'>
                                {value?.email}
                            </span>
                        </div>
                    ) : (
                        <div>{label}</div>
                    )
                }
                isOptionSelected={(option) => option.value?.id === selectedCustomer?.id}
                isLoading={isFetching}
            />
        </div>
    );
};

export default SelectCustomerDD;
